export interface CarrierData {
	// Active Carrier Instance fields (for protection logic)
	CarrierInstanceId: number | null;
	CarrierPartId: number | null;
	CarrierName: string | null;
	CarrierStatusCode: string | null;
	CarrierStatusName: string | null;
	IsInActiveCarrier: boolean;
}

export const CARRIER_DATA_INITIAL_VALUES: CarrierData = {
	// Active Carrier Instance fields
	CarrierInstanceId: null,
	CarrierPartId: null,
	CarrierName: null,
	CarrierStatusCode: null,
	CarrierStatusName: null,
	IsInActiveCarrier: false,
};
